export default __webpack_public_path__ + "static/media/road_img_2_3.e67fc703.jpg";